import usePrivateAxios from "@/common/api/usePrivateAxios"
import { transformNewRoles } from "@/common/utils/roleTransformers";
import { removeSpecialCharacters } from "@/common/utils/unFormatters"
import { EstablishmentUserValidationSchema } from "@/features/establishments/schemas/create.schema"
import { useMutation } from "@tanstack/react-query"
import { AxiosError, AxiosResponse } from "axios";

interface UseCreateEstablishmentUser {
  companyId?: string,
  companyBranchId?: string,
  file: Blob | undefined,
  onSuccess: (response: AxiosResponse) => void,
  onError?: (error: AxiosError) => void;
}

export const useCreateEstablishmentUser = ({
  companyId,
  companyBranchId,
  file,
  onSuccess,
  onError,
}: UseCreateEstablishmentUser) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createEstablishmentUser'],
    mutationFn: async (form: EstablishmentUserValidationSchema) => {
      const payload = {
        company_id: companyId,
        company_branch_id: companyBranchId,
        cpf: removeSpecialCharacters(form.cpf),
        date_of_birth: form.date_of_birth || null,
        full_name: form.full_name,
        status: form?.status?.value || 'enabled',
        phone_attributes: form?.phone?.number
          ? { number: form?.phone?.number ? removeSpecialCharacters(form?.phone?.number) : null }
          : undefined,
        email: form.email || null,
        user_roles_attributes: form?.roles?.length ? form.roles.map(transformNewRoles) : [],
        profile_picture: file ? file : undefined
      }

      return privateAxios.postForm('/establishment/users', { establishment_user: payload })
    },
    onSuccess,
    onError,
  })
}
